import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "TransferElement",
  ref: "transferElement"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.isInit ? _renderSlot(_ctx.$slots, "default", {
    key: 0
  }) : _createCommentVNode("", true)], 512)), [[_vShow, _ctx.isShow]]);
}